<template lang="pug">
  .footer
    .menu
      a(href="https://filecat.me/software-license/") EULA
      .sep •
      a(href="https://filecat.me/terms-of-service/") Terms of Service
      .sep •
      a(href="https://filecat.me/policies/") Polices
    p FileCat OÜ • Registry Code 14602139 • Punаnе tn 56, Tаllinn, Estоnіа 13619 • Tel: +3726188389
    p Copyright 2019. All Rights Reserved.
</template>

<script>
export default {
}
</script>

<style lang="stylus" scoped>
  .footer
    text-align: center
    background: #262626
    color: #DDDDDD
    font-size: 14px
    line-height: 40px
    padding: 15px 10px

  .menu
    display: flex
    justify-content: center

    a
      color: #999999
      &:hover
        color: inherit

    .sep
      padding: 0 8px
      color: #999999
</style>
